module.exports = __webpack_public_path__ + "img/floorplan_gulfstreamG500_day.713d4710.png";